import React from 'react'
import { Link } from 'react-router-dom'
import Header from './Header'

const StoriesPage: React.FC = () => {
	return (
		<div className="full-screen full-nav bg-blue">
			<Header color={'#4169e0'} />
			<div className="stories-card-container">
				<div>
					<div className="stories-card bg-salmon">
						<Link
							to="/stories/top"
							className="w-full h-full flex-center remove-decoration remove-tap-highlight">
							<span>Top stories</span>
						</Link>
					</div>
				</div>
				<div>
					<div className="stories-card bg-salmon">
						<Link
							to="/stories/best"
							className="w-full h-full flex-center remove-decoration remove-tap-highlight">
							<span>Best stories</span>
						</Link>
					</div>
				</div>
				<div>
					<div className="stories-card bg-salmon">
						<Link
							to="/stories/new"
							className="w-full h-full flex-center remove-decoration remove-tap-highlight">
							<span>New stories</span>
						</Link>
					</div>
				</div>
			</div>
		</div>
	)
}

export default StoriesPage
